import Drilldown from 'components/drilldown/Layout'
import impressionStore from 'modules/report/stores/impression'

import { formatters } from 'components/hierarchical-report/utils'

export default class ImpressionsDrilldown extends Drilldown {
  store = impressionStore
  collection = 'Impressions'
  report = 'impressions'

  metrics = {
    completed: { label: 'Completed', field: 'completed', value: true },
    notCompleted: { label: 'Not completed', field: 'completed', value: false },
    total: { label: 'Total' },
  }

  fields = {
    default: ['pageName', 'pageType', 'pathName', 'siteName', 'organizationName', 'userEmail', 'completed'],
    options: [
      { group: 'General', value: 'impressionAction', label: 'Action' },
      { group: 'General', value: 'completed', label: 'Completed' },
      { group: 'General', value: 'completedOrigin', label: 'Completed Origin' },
      { group: 'General', value: 'optout', label: 'Optout' },
      { group: 'General', value: 'pathSessionId', label: 'Path Session Id' },
      { group: 'General', value: 'pathUserProfileId', label: 'Path User Profile Id' },

      { group: 'User Session', value: 'userSessionId', label: 'Id' },
      { group: 'User Session', value: 'userSessionCreatedAt', label: 'Created At' },
      { group: 'User Session', value: 'duplicated', label: 'Duplicated' },
      { group: 'User Session', value: 'registrationCompleted', label: 'Registration Completed' },

      { group: 'Revenue', value: 'revenueOrigins', label: 'Origins' },
      { group: 'Revenue', value: 'revenueTransactionIds', label: 'Transactions Ids' },
      { group: 'Revenue', value: 'revenueIntegrationIds', label: 'Integrations Ids' },
      { group: 'Revenue', value: 'revenue', label: 'Total' },

      { group: 'User', value: 'userId', label: 'Id' },
      { group: 'User', value: 'userCreatedAt', label: 'Created At' },
      { group: 'User', value: 'userUpdatedAt', label: 'Updated At' },
      { group: 'User', value: 'userFirstName', label: 'First Name' },
      { group: 'User', value: 'userLastName', label: 'Last Name' },
      { group: 'User', value: 'userEmail', label: 'Email' },
      { group: 'User', value: 'userEmailDomain', label: 'Email Domain' },
      { group: 'User', value: 'userAddress1', label: 'Address 1' },
      { group: 'User', value: 'userAddress2', label: 'Address 2' },
      { group: 'User', value: 'userCity', label: 'City' },
      { group: 'User', value: 'userState', label: 'State' },
      { group: 'User', value: 'userZip', label: 'Zip' },
      { group: 'User', value: 'userCountry', label: 'Country' },
      { group: 'User', value: 'userPhone', label: 'Phone' },
      { group: 'User', value: 'userDob', label: 'Date of Birth' },
      { group: 'User', value: 'userAge', label: 'Age' },
      { group: 'User', value: 'userGender', label: 'Gender' },
      { group: 'User', value: 'userUnsubscribed', label: 'Unsubscribed' },
      { group: 'User', value: 'userValidated', label: 'Validated' },

      { group: 'Path', value: 'pathId', label: 'Id' },
      { group: 'Path', value: 'pathCreatedAt', label: 'Created At' },
      { group: 'Path', value: 'pathUpdatedAt', label: 'Updated At' },
      { group: 'Path', value: 'pathName', label: 'Name' },
      { group: 'Path', value: 'pathActive', label: 'Active' },
      { group: 'Path', value: 'pathContainerSlotId', label: 'Container Slot Id' },
      { group: 'Path', value: 'experimentVersion', label: 'Experiment Version' },

      { group: 'Page', value: 'pageId', label: 'Id' },
      { group: 'Page', value: 'pageCreatedAt', label: 'Created At' },
      { group: 'Page', value: 'pageUpdatedAt', label: 'Updated At' },
      { group: 'Page', value: 'pageName', label: 'Name' },
      { group: 'Page', value: 'pageType', label: 'Type' },
      { group: 'Page', value: 'validatePlacementTimeout', label: 'Placement Timeout' },

      { group: 'Site', value: 'siteId', label: 'Id' },
      { group: 'Site', value: 'siteCreatedAt', label: 'Created At' },
      { group: 'Site', value: 'siteUpdatedAt', label: 'Updated At' },
      { group: 'Site', value: 'siteName', label: 'Name' },
      { group: 'Site', value: 'siteDomain', label: 'Domain' },
      { group: 'Site', value: 'siteDomainAliases', label: 'Domain Aliases' },

      { group: 'Organization', value: 'organizationId', label: 'Id' },
      { group: 'Organization', value: 'organizationCreatedAt', label: 'Created At' },
      { group: 'Organization', value: 'organizationUpdatedAt', label: 'Updated At' },
      { group: 'Organization', value: 'organizationName', label: 'Name' },
      { group: 'Organization', value: 'organizationActive', label: 'Active' },
      { group: 'Organization', value: 'organizationTimezone', label: 'Timezone' },

      { group: 'Request', value: 'requestDate', label: 'Date' },
      { group: 'Request', value: 'slotPosition', label: 'Slot Position' },
      { group: 'Request', value: 'requestPid', label: 'Pid' },
      { group: 'Request', value: 'requestSid1', label: 'SubID 1' },
      { group: 'Request', value: 'requestSid2', label: 'SubID 2' },
      { group: 'Request', value: 'requestSid3', label: 'SubID 3' },
      { group: 'Request', value: 'ip', label: 'Ip' },
      { group: 'Request', value: 'deviceType', label: 'Device Type' },
      { group: 'Request', value: 'deviceGrade', label: 'Device Grade' },
      { group: 'Request', value: 'referrer', label: 'Referrer' },
      { group: 'Request', value: 'encoding', label: 'Accept Encoding' },
      { group: 'Request', value: 'language', label: 'Accept Language' },
      { group: 'Request', value: 'requestUrl', label: 'URL' },
      { group: 'Request', value: 'method', label: 'Method' },
      { group: 'Request', value: 'embedUrlOverride', label: 'Embed URL Override' },
      { group: 'Request', value: 'embedDuplicateUser', label: 'Embed Duplicate' },
      { group: 'Request', value: 'embedDefaultPathOverride', label: 'Embed Default Path Override' },
      { group: 'Request', value: 'embedPathOverride', label: 'Embed Path Override' },
      { group: 'Request', value: 'allocationId', label: 'Allocation' },

      { group: 'Survey', value: 'surveyField', label: 'Field' },
      { group: 'Survey', value: 'surveyVersion', label: 'Version' },
      { group: 'Survey', value: 'surveyAnswer', label: 'Answer' },

    ],
    fieldsFormatters: {
      userId: cell => formatters.openNewTab("/reports/audit", { key: "id", value: cell }),
      userEmail: cell => formatters.openNewTab("/reports/audit", { key: "email", value: cell }),
      userPhone: cell => formatters.openNewTab("/reports/audit", { key: "phone", value: cell })
    }
  }
}
